import { render, staticRenderFns } from "./videoType.vue?vue&type=template&id=3b36d9ec&scoped=true"
import script from "./videoType.vue?vue&type=script&lang=js"
export * from "./videoType.vue?vue&type=script&lang=js"
import style0 from "./videoType.vue?vue&type=style&index=0&id=3b36d9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b36d9ec",
  null
  
)

export default component.exports